"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../../api/webAApi");
var EventBindingOnLoginCfgCtl = /** @class */ (function (_super) {
    __extends(EventBindingOnLoginCfgCtl, _super);
    function EventBindingOnLoginCfgCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this._errDialog = errDialog;
        return _this;
    }
    EventBindingOnLoginCfgCtl.prototype.ResetData = function () {
        this.DATA = {
            is_bonus_create_only_on_useragent_part: false,
            useragent_part_to_bonus_create_on: "",
        };
    };
    EventBindingOnLoginCfgCtl.prototype.LoadData = function (key, onDone) {
        var _this = this;
        webAApi_1.DetailsBrandBonusEventBindingConfigOnLogin.exec({ event_binding_id: key }, function (resp) {
            _this.DATA.is_bonus_create_only_on_useragent_part = resp.is_bonus_create_only_on_useragent_part;
            _this.DATA.useragent_part_to_bonus_create_on = resp.useragent_part_to_bonus_create_on;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    EventBindingOnLoginCfgCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoEditBrandBonusEventBindingConfigOnLogin.exec({
            data: {
                event_binding_id: data.event_binding_id,
                is_bonus_create_only_on_useragent_part: data.is_bonus_create_only_on_useragent_part,
                useragent_part_to_bonus_create_on: data.useragent_part_to_bonus_create_on,
            }
        }, function (resp) {
            _this.DATA.is_bonus_create_only_on_useragent_part = data.is_bonus_create_only_on_useragent_part;
            _this.DATA.useragent_part_to_bonus_create_on = data.useragent_part_to_bonus_create_on;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return EventBindingOnLoginCfgCtl;
}(BaseController_1.BaseController));
exports.EventBindingOnLoginCfgCtl = EventBindingOnLoginCfgCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_events_bindings/ctl/event_config/config_on_login/EventBindingOnLoginCfgCtl.ts
// module id = 1035
// module chunks = 0